import styles from './_postsFilter.module.scss'
import classNames from 'classnames'
import { Dispatch, SetStateAction, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { SortCommunityPostsEnum } from '../../../../__generated__/graphql'

const PostsFilter: React.FC<{
  selectedFilter: SortCommunityPostsEnum
  setSelectedFilter: Dispatch<SetStateAction<SortCommunityPostsEnum>>
}> = ({ selectedFilter, setSelectedFilter }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownOptions = Object.values(SortCommunityPostsEnum).filter(
    (option) => option !== selectedFilter
  )

  return (
    <div className={styles.filterDropdownContainer}>
      <div
        className={classNames(
          styles.filterDropdown,
          isDropdownOpen && styles.filterDropdownOpen
        )}
      >
        <button
          className={styles.toggleDropdownButton}
          onClick={() => setIsDropdownOpen((open) => !open)}
        >
          {isDropdownOpen ? (
            <FontAwesomeIcon icon={faCaretUp} size="lg" />
          ) : (
            <FontAwesomeIcon icon={faCaretDown} size="lg" />
          )}
          <span className={styles.filterDropdownButtonText}>
            {selectedFilter.toLowerCase()}
          </span>
        </button>

        {isDropdownOpen && (
          <div className={styles.dropdownOptions}>
            {dropdownOptions.map((option) => (
              <div
                key={option}
                className={styles.option}
                onClick={() => setSelectedFilter(option)}
              >
                {option.toLowerCase()}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default PostsFilter
